import { isFinite } from "lodash";
import { NumberFormatValues } from "react-number-format";

export function guardNum(
  prev: number | string,
  next: string | number,
  convert = false
): number | string {
  if (next === "") {
    return next;
  }

  const converted = Number(next);
  if (isFinite(converted)) {
    return convert ? converted : next;
  }

  return prev;
}

export const moneyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

export function zeroToEmptyString(num: number) {
  return num === 0 ? "" : num;
}

/**
 * for use with react-number-format to convert empty strings to zero
 * @param vals
 */
export function emptyNumberFormatToZero(vals: NumberFormatValues) {
  return vals.value === "" ? 0 : vals.floatValue;
}

/**
 * calculates X% of Y
 * @param pct
 * @param num
 */
export function percentOfNum(pct: number, num: number) {
  return num * (pct / 100);
}

/**
 * calculates what % X is of Y (reverse of percentOfNum)
 * @param num
 * @param total
 */
export function percentOfTotal(num: number, total: number) {
  return (num / total) * 100;
}



// WEBPACK FOOTER //
// ./app/javascript/utils/numbers.ts